import { render, staticRenderFns } from "./labelTags.vue?vue&type=template&id=35f66f32&"
import script from "./labelTags.vue?vue&type=script&lang=js&"
export * from "./labelTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports